import { clPublicSimulator } from './clPublicSimulator';

export * from './flowManager';

export const flows = {
	clPublicSimulator,
};

export type Flows = keyof typeof flows;
